module.exports = __webpack_public_path__ + "img/2.7827f834.png";